import { SciDomainsPage } from 'features/sci-domains';

export const TechOperatorSciDomainsPage: React.FC = () => <SciDomainsPage />;
